import{z as e}from"zod";const t=e.string().min(1,{message:`users.form.name.required`}).max(255,{message:`users.form.name.maxLength`});export{t as userNameSchema};
//# sourceMappingURL=user.schema.mjs.map